import { getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js/min';

const REGIONAL_INDICATOR_OFFSET = 127397;

export function countryFlag(alpha2) {
	const normalized = String(alpha2 || '').trim().toUpperCase();
	if (!/^[A-Z]{2}$/.test(normalized)) return '';
	return [...normalized]
		.map((letter) => String.fromCodePoint(letter.charCodeAt(0) + REGIONAL_INDICATOR_OFFSET))
		.join('');
}

export function toE164(country, nationalNumber) {
	if (!country || !String(nationalNumber).trim()) return null;
	const parsed = parsePhoneNumberFromString(String(nationalNumber), country);
	return parsed?.isValid() ? parsed.number : null;
}

export function countryOptions(countries = []) {
	return countries.flatMap((country) => {
		const alpha2 = String(country.alpha2 || '').toUpperCase();
		try {
			return [{
				name: country.name,
				alpha2,
				callingCode: getCountryCallingCode(alpha2),
				flag: countryFlag(alpha2),
			}];
		} catch {
			return [];
		}
	});
}

export function filterCountryOptions(options, query) {
	const normalized = String(query || '').trim().toLowerCase();
	if (!normalized) return options;
	const callingCodeQuery = normalized.replace(/^\+/, '');

	return options.filter((option) => (
		String(option.name || '').toLowerCase().includes(normalized)
		|| String(option.alpha2 || '').toLowerCase().includes(normalized)
		|| String(option.callingCode || '').includes(callingCodeQuery)
	));
}
